module.exports = __webpack_public_path__ + "static/media/people.a4248552.png";